import { Pipe, PipeTransform } from '@angular/core';
import { merge } from 'lodash';

@Pipe({ name: 'reviewTableColumnOptions' })
export class ReviewTableColumnOptionsPipe implements PipeTransform {
	/**
	 * Add the base datapoint to the column datapoint
	 * 
	 * @param options Original options
	 * @param index Index of the row
	 * @param base Base datapoint
	 */
	transform(options: any, index: number, base: string): Record<string, unknown> {
		if ('isFullPath' in options) {
			return options;
		}
		
		const path = `${base}[${index}].${options.path}`;
		const nOptions = Object.assign({}, options);
		Object.assign(nOptions, { path });

		return nOptions;
	}
}

@Pipe({ name: 'reviewNestedTableOptions' })
export class ReviewNestedTableOptionsPipe implements PipeTransform {
	/**
	 * Add the base datapoint to nested table
	 * 
	 * @param options Original options
	 * @param index Index of the row
	 * @param base Base datapoint
	 */
	transform(options: any, index: number, base: string): Promise<Record<string, unknown>> {
		const path = `${base}[${index}].${options.options.path}`;
		const nOptions = merge({}, options);
		Object.assign(nOptions.options, { path });

		return nOptions;
	}
}

@Pipe({ name: 'onlyRealColumns' })
export class OnlyRealColumnsPipe implements PipeTransform {
	
	/**
	 * Return only field columns.
	 * 
	 * @param columns Columns array
	 */
	transform(columns: Array<any>): Array<any> {
		return columns.filter(column => {
			return column.type !== 'table';
		});
	}
}

@Pipe({ name: 'replaceIndex' })
export class ReplaceIndexFromOptionsPipe implements PipeTransform {
	/**
	 * Add the base datapoint to the column datapoint
	 * 
	 * @param options Original options
	 * @param index Index of the row
	 * @param base Base datapoint
	 */
	transform(options: any, index: string): Record<string, unknown> {
		const indexArray = (index + '').split('-');
		const pattern = /\{index\}/gm;
		const testPath = options.path;

		let i = 0;
		const path = testPath.replace(pattern, function(s: any, key: string | number): any {
			const replace = indexArray[i];
			i++;
			return replace || s;
		});

		const nOptions = Object.assign({}, options);
		Object.assign(nOptions, { path });

		return nOptions;
	}
}

@Pipe({ name: 'replacePointerIndex' })
export class ReplacePointerIndexFromOptionsPipe implements PipeTransform {
	/**
	 * Add the base path from the data pointer
	 *
	 * @param options Original options
	 * @param index Index of the row
	 * @param base Base datapoint
	 */
	transform(options: any, index: string): Record<string, unknown> {
		const indexArray = (index + '').split('-');
		const pattern = /\/-\//gm;
		let path = '';
		if (options.path && options.path.length > 0) {
			if (options.path.slice(-1) === '-') {
				options.path = options.path + '/';
			}
			const testPath = options.path; // Last

			let i = 0;
			path = testPath.replace(pattern, function (s: any, key: string | number): any {
				const replace = indexArray[i];
				i++;
				return '[' + (replace || s) + '].';
			});
			
			// eslint-disable-next-line
			path = path.replace(/^[\.\/]{0,2}|[\.\/]{0,2}$/, '');
			// eslint-disable-next-line
			path = path.replace(/[\.\/]{0,2}$/, '');
			path = path.replace(/\//g, '.');
		}

		const nOptions = Object.assign({}, options);
		Object.assign(nOptions, {path});

		return nOptions;
	}
}
